import {
  MonitorJsSdk,
  SDKPluginApi,
  SDKPluginException,
  SDKPluginPerformance,
  SDKPluginResource,
  markBizMetricsEnd,
  markBizMetricsStart,
} from '@shopee-ee/monitor-js-sdk';
import { v4 as uuidv4 } from 'uuid';

import { localStorageKey } from '@contants/storageKeys';

let deviceID = localStorage.getItem(localStorageKey.deviceID);
if (!deviceID) {
  deviceID = uuidv4();
  localStorage.setItem(localStorageKey.deviceID, deviceID);
}

const sdk = new MonitorJsSdk({
  projectID: 'attendance',
  userID: localStorage.getItem(localStorageKey.lastLoginEmail) || '',
  deviceID,
  env: process.env.REACT_APP_ENV || 'test',
  source: 'web',
});

const apiPlugin = new SDKPluginApi({
  paths: ['/api'],
  extraData(xhr) {
    if (xhr instanceof XMLHttpRequest) {
      return {
        XRequestId: xhr.getResponseHeader('x-request-id'),
      };
    }
    if (xhr instanceof Response) {
      return {
        XRequestId: xhr.headers.get('x-request-id'),
      };
    }
    return undefined;
  },
});
const exceptionPlugin = new SDKPluginException();
const performancePlugin = new SDKPluginPerformance();
const resourcePlugin = new SDKPluginResource();

sdk.use(apiPlugin);
sdk.use(exceptionPlugin);
sdk.use(performancePlugin);
sdk.use(resourcePlugin);

export { markBizMetricsEnd as markBizEnd, markBizMetricsStart as markBizStart };
